// Putting a reply or a prompt on the clipboard: through the Clipboard API
// when the page has it, else through a hidden textarea and
// `execCommand('copy')`. Moved from today's pages (markdown/copy.ts there),
// without its code blocks' buttons.

/** How long a copy button says "Copied". */
export const COPIED_MS = 1500

/** The hidden-textarea route, for pages without the Clipboard API. */
function copyWithTextarea(text: string): boolean {
  const active = document.activeElement instanceof HTMLElement ? document.activeElement : null
  const area = document.createElement('textarea')
  area.value = text
  area.setAttribute('readonly', '')
  area.setAttribute('aria-hidden', 'true')
  area.tabIndex = -1
  Object.assign(area.style, { position: 'fixed', top: '0', left: '0', width: '1px', height: '1px', opacity: '0', pointerEvents: 'none' })
  document.body.append(area)
  let copied = false
  try {
    area.focus({ preventScroll: true })
    area.select()
    area.setSelectionRange(0, text.length)
    copied = typeof document.execCommand === 'function' && document.execCommand('copy')
  } catch {
    copied = false
  } finally {
    area.remove()
    active?.focus({ preventScroll: true })
  }
  return copied
}

/** Puts `text` on the clipboard; false when neither route worked. */
export async function copyText(text: string): Promise<boolean> {
  const clipboard = typeof navigator === 'undefined' ? undefined : navigator.clipboard
  if (clipboard && typeof clipboard.writeText === 'function') {
    try {
      await clipboard.writeText(text)
      return true
    } catch {
      // Refused (no permission, not focused): the older route may still work.
    }
  }
  return copyWithTextarea(text)
}
